export const getDocumentHash = () => {
    const tag = document.querySelector("meta[name='ui-version']");
    if (tag) {
        return tag.content || '';
    }
    return '';
};
//# sourceMappingURL=getDocumentHash.js.map